import WashdayClientSingleton from './WashdayClientSingleton';
import { IOutsourcedOrdersQueryParams, OutsourcedStatus } from '../hooks/outsourcingOrders/interfaces';

export const getOutsourcedOrdersByStore = async (params: IOutsourcedOrdersQueryParams) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    return await WashdayClientSingleton.getInstance().outsourcedOrders.getOutsourcedOrdersByStore(filteredParams);
  } catch (e) {
    console.log('[ERROR] getOutsourcedOrdersByStore', e);
    throw e;
  }
};

export const getOutsourcedOrdersByOrder = async (orderId: string, params: {
  partnerId?: string;
  statuses?: OutsourcedStatus[];
} = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    return await WashdayClientSingleton.getInstance().outsourcedOrders.getOutsourcedOrdersByOrder(orderId, filteredParams);
  } catch (e) {
    console.log('[ERROR] getOutsourcedOrdersByOrder', e);
    throw e;
  }
};

export const updateOutsourcedOrderById = async (id: string, data: {
  partner?: string,
  outsourcedStatus?: "pending" | "in_process" | "returned",
  sentDate?: string,
  receivedDate?: string,
  externalOrderId?: string,
}) => {
  try {
    return await WashdayClientSingleton.getInstance().outsourcedOrders.updateOutsourcedOrderById(id, data);
  } catch (e) {
    console.log('[ERROR] updateOutsourcedOrderById', e);
    throw e;
  }
};

export const deleteOutsourcedOrderById = async (id: string) => {
  try {
    return await WashdayClientSingleton.getInstance().outsourcedOrders.deleteOutsourcedOrderById(id);
  } catch (e) {
    console.log('[ERROR] deleteOutsourcedOrderById', e);
    throw e;
  }
};
